import { MetadataContent } from '@jutro/legacy/uiconfig';
import styles from './PaymentInfoExt.module.scss';
import metadata from './PaymentInfoExt.metadata.json5';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useEffect, useState, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import messages from './PaymentInfoExt.messages';
import { useTranslator } from '@jutro/locale';


function PaymentInfoExt(props) {
    const { history } = props;
    const translator = useTranslator();

    const { AccountBillingDetailsService: BillingService } = useDependencies(
        'AccountBillingDetailsService'
    );
    const { authHeader } = useAuthentication();
    const [isLoadingData, updateIsLoadingData] = useState(false);
    const invoiceName = window.sessionStorage?.invoiceName
    const invoiceStreamId = window.sessionStorage?.invoiceStreamId /// added in session to get the invoices
    const queryParams = new URLSearchParams(window.location.search);
    const status = queryParams.get('Result');
    const paymentToken = queryParams.get('CUSTOM_ID2');
    const amountRequest = queryParams.get('AMOUNT');
    const accountNumber = queryParams.get('ORDER_ID');
    const refId = queryParams.get('ID');
    let email = queryParams.get('EMAIL');
    const emailAccount = email.split(' ');
    email = emailAccount[0];
    const miltiStreamCode = queryParams.get('DBA');
    const DBASplit = miltiStreamCode.split('  ');

    const getStatus = useMemo(() => {
        return  status.toUpperCase().trim() == "APPROVED";
     }, [status]);

    useEffect(() => {
        const data = {
            Result: queryParams.get('Result'),
            CustomId2: queryParams.get('CUSTOM_ID2'),
            Amount: queryParams.get('AMOUNT'),
            OrderId: queryParams.get('ORDER_ID'),
            KeyBPStamp: queryParams.get('BP_STAMP'),
            KeyRRno: queryParams.get('RRNO'),
            KeyIssueDate: queryParams.get('ISSUE_DATE'),
            PaymentAccount: queryParams.get('PAYMENT_ACCOUNT'),
            InvoiceID: queryParams.get('INVOICE_ID'),
            Email: email,
            invoiceStreamId: invoiceStreamId,
            invoiceStreamName: invoiceName
        };
        updateIsLoadingData(true);
        BillingService.updateCreditCardPaymentDetails(data, authHeader)
            .then(res => {
                if (res) {
                    history.push({
                        pathname: `/billing-summary`,
                        state: {
                            redirectPath: '/',
                            message: 'PaymentSuccessful',
                            referenceId: refId,
                            accountNumber: emailAccount[2],
                            invoiceStreamID: invoiceStreamId,
                            invoiceStreamName: invoiceName,
                            multiStreamDropDownArray: DBASplit[2]

                        },
                        search: `?refId=${refId}`,
                    });
                }
            })
            .finally(() => {
                updateIsLoadingData(false);
            });
    }, []);

    const continueClick = ()=>{
        history.push(JSON.parse(window.sessionStorage.getItem('make-payment')));
    }

   
    const overrides = {
        successDiv:{
          visible: getStatus
        },
        inlinenotification:{
            message:translator(messages.paymentLoading)
        },
        failureDiv:{
            visible: !getStatus
        },
        paymentDeclinedMessage:{
            content:translator(messages.paymentDeclineMessage)
        },
        paymentDeclinedInstruction:{
            content:translator(messages.paymentDeclineInstruction)
        },
        pageLoader: {
            loaded: !isLoadingData,
            loadingMessage: translator(messages.paymentLoading),
            visible: isLoadingData,
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            
        },
        resolveCallbackMap:{
            continueClick:continueClick
        }
    };

    // eslint-disable-next-line react/react-in-jsx-scope
    return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;

}
export default withRouter(PaymentInfoExt);
